<ng-container *transloco="let t">
  <section class="banner">
    <div class="content" [class.mobile]="!(biggerThan$ | async)?.mobileL">
      <div class="wrapper">
        @if (!rtlMode) {
          <h2>Sign up to get an exclusive discount!</h2>
          <span
            >Join our text marketing for exclusive deals and a chance to win an iPhone 15
          </span>
        } @else {
          <h2>قم بتسجيل الدخول للحصول على خصم حصري!</h2>
          <span
            >انضم إلى خدمة التسويق النصية للحصول على صفقات وفرصة ربح جهاز آيفون 15
          </span>
        }
        <span class="fixed-space-16" aria-hidden="true"></span>
        <div
          class="subscribe-banner-component popsy-button pill"
          [class.focus]="inFocus"
          [class.mobileL]="(biggerThan$ | async)?.mobileL"
          (click)="inFocus = true">
          <div class="text">
            @if (subscribeType !== 'location') {
              <input
                data-clarity-unmask
                #subscribeField
                type="email"
                inputmode="email"
                class="field subscribe-field"
                [class.focus]="inFocus"
                role="subscribe"
                [attr.aria-label]="t('hint_subscribe')"
                (focus)="inFocus = true"
                (focusout)="inFocus = false"
                [class.error]="
                  submitted &&
                  (formControl.hasError('required') || formControl.hasError('email'))
                "
                [formControl]="formControl"
                [placeholder]="t('hint_email')"
                (keydown.enter)="onSubscribeToNewsletter()" />
            }
            @if (subscribeType !== 'location' && queryParams?.text) {
              <a
                role="button"
                class="clear-subscribe-button"
                [attr.aria-label]="t('aria_filter_disable')">
                <popsy-icon-remove class="icon closeIcon gray-01"></popsy-icon-remove>
              </a>
            }
          </div>

          @if (!rtlMode) {
            <popsy-icon-keyboard-arrow-right
              class="subscribe-icon"
              (click)="onSubscribeToNewsletter()"></popsy-icon-keyboard-arrow-right>
          }
          @if (rtlMode) {
            <popsy-icon-keyboard-arrow-left
              class="subscribe-icon"
              (click)="onSubscribeToNewsletter()"></popsy-icon-keyboard-arrow-left>
          }
        </div>
        <span class="fixed-space-8" aria-hidden="true"></span>
        @if (
          submitted && (formControl.hasError('required') || formControl.hasError('email'))
        ) {
          <span class="text-highlight small">{{ t('error_email_not_valid') }}</span>
        }
        @if (
          submitted &&
          !(subscribed$ | async) &&
          !(formControl.hasError('required') || formControl.hasError('email'))
        ) {
          <span class="text-highlight small">{{ t('error_reset_password') }}</span>
        }
        @if (subscribed$ | async) {
          <span class="text-highlight small">
            {{ t('label_subscribe_newsletter_success') }}
          </span>
        }
      </div>
      @if ((biggerThan$ | async)?.mobileL) {
        <div class="image-fit-wrapper">
          <app-picture
            class="image"
            [lazyLoad]="false"
            pictureUrl="/assets/banners/subscribe_banner.webp"
            [alt]="t('featured_banner_title')"></app-picture>
        </div>
      }
    </div>
    <span class="fixed-space-32" aria-hidden="true"></span>
  </section>
</ng-container>
